/**
 * AppHeader — 앱 화면 상단의 브랜드 바.
 * @description 콜랩 상세는 링크를 타고 처음 오는 사람이 대부분이다. 그 사람에게 이 화면은
 *   **출처 없는 페이지**다 — 누가 만든 무엇인지가 어디에도 없으면, 아래 CTA 의 「앱에서
 *   이어서」 가 어느 앱을 말하는지조차 알 수 없다. 그래서 첫 줄에 이름을 둔다.
 *
 *   랜딩과 같은 워드마크·같은 파랑을 쓴다. 앱 패널은 흰 바탕이라 흰 워드마크를 그대로 얹을
 *   수 없어서, 바를 브랜드 색으로 깔고 그 위에 올린다. 라이트·다크 어느 쪽에서도 같은
 *   대비가 나오는 조합이기도 하다.
 *
 *   스크롤을 따라 붙어 있는다 — 상세가 길어서, 중간부터 읽는 사람에게도 이름이 남아 있어야 한다.
 */
import Image from "next/image";
import Link from "next/link";
import type { ReactNode } from "react";

import { SITE_NAME } from "@/shared/config";

/**
 * 바 높이. 48 이다.
 * @description 56 은 두꺼웠다. 이 바가 지는 일은 이름을 알리는 것 하나뿐이라, 커버 사진이
 *   시작되기 전에 화면을 그만큼 먹을 이유가 없다.
 */
const BAR_HEIGHT = "h-12";

/** 워드마크 높이. 바의 절반 — 이름이 먼저 읽혀야 하는 자리라 크게 잡는다. */
const WORDMARK_HEIGHT = 24;

export function AppHeader({ right }: { right?: ReactNode }) {
  return (
    <header
      className={`sticky top-0 z-20 flex ${BAR_HEIGHT} shrink-0 items-center justify-between gap-[var(--fw-space-gap-sm)] bg-primary px-[var(--fw-space-inset-screen)]`}
    >
      <Link href="/" aria-label={SITE_NAME} className="flex items-center">
        <Image
          src="/assets/images/logo-expanded.png"
          alt={SITE_NAME}
          width={216}
          height={81}
          priority
          className="w-auto"
          style={{ height: WORDMARK_HEIGHT }}
        />
      </Link>
      {right}
    </header>
  );
}
